import React, { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { IconButton } from '@material-ui/core'
import CachedIcon from '@material-ui/icons/Cached'

import { Q_ENVIRONMENT } from 'graphql/query'
import styles from './bins.module.scss'

const Defaults = () => {
  // const [apiEnvDefault, setApiEnvDfault] = useState(2)
  // const [envDefault, setEnvDefault] = useState(apiEnvDefault)
  // const [envValues, setEnvValues] = useState([])

  // const { refetch } = useQuery(Q_ENVIRONMENT)
  // useEffect(() => {
  //   refetch() &&
  //     refetch().then(res => {
  //       setEnvValues(res.data.getEnvironment)
  //     })
  // }, [refetch])
  // const handleEnvChange = event => {
  //   setEnvDefault(event.target.value)
  // }
  // const updateApiEnv = () => {
  //   setApiEnvDfault(1)
  //   console.log(apiEnvDefault, envDefault)
  // }
  return (
    // <div className={styles.defaults}>
    //   <div className={styles.default}>
    //     <div>
    //       <div>Environment</div>
    //       <Select
    //         labelId="demo-simple-select-label"
    //         id="demo-simple-select"
    //         value={envDefault}
    //         onChange={handleEnvChange}
    //         className={styles.select}
    //       >
    //         {envValues.map(env => (
    //           <MenuItem value={parseInt(env.id)} key={env.id}>
    //             {env.name}
    //           </MenuItem>
    //         ))}
    //       </Select>
    //     </div>
    //     <IconButton
    //       color="primary"
    //       disabled={apiEnvDefault === envDefault}
    //       onClick={() => updateApiEnv()}
    //       variant="contained"
    //     >
    //       <CachedIcon />
    //     </IconButton>
    //   </div>
    // </div>
    null
  )
}
export default Defaults
